<template>
  <v-form ref="customerForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="12" xs="12" md="6">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Customer Name"
          v-model="record.Name"
          :rules="inputRules"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Phone"
          v-model="record.PhoneNumber"
          :rules="inputRules"
        ></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field
          type="text"
          autocomplete="off"
          outlined
          dense
          label="Email"
          v-model="record.Email"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn
          color="accent"
          @click="sendData"
          :loading="$store.state.btnLoader"
        >
          <v-icon left>mdi-content-save</v-icon>Create
        </v-btn>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    inputRules: [v => !!v || "Required"],
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.customerForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

        this.loader = true;
        this.$store.commit("btnLoader", true);
        this.$emit("data", this.record);
    },
  },
};
</script>